import { inject, Injectable } from '@angular/core';
import type { SrmTicketStatusType } from '@libs/services/models';
import { FileSaverService } from '@libs/shared/services';

export enum ColumnLabels {
  SRM_TICKET_DATE = 'Datum',
  SRM_TICKET_SUBJECT = 'Betreff',
  SRM_TICKET_NUMBER = 'Ticketnummer',
  SRM_TICKET_STATUS = 'Status',
  ACTIONS = 'Aktionen',
}

export const TicketStatus: Record<SrmTicketStatusType, string> = {
  OPEN: 'offen',
  IN_PROGRESS: 'In Bearbeitung',
  COMPLETED: 'geschlossen',
};

@Injectable({ providedIn: 'root' })
export class SrmHelperService {
  public readonly ColumnLabels: typeof ColumnLabels = ColumnLabels;

  private readonly fileSaverService: FileSaverService = inject(FileSaverService);

  public translateStatus(status: SrmTicketStatusType | undefined): string {
    return TicketStatus[status ?? 'OPEN'] ?? 'unbekannt';
  }

  public statusStyle(status: SrmTicketStatusType | undefined): string {
    switch (status) {
      case 'OPEN':
        return 'pending';
      case 'IN_PROGRESS':
        return 'in-progress';
      case 'COMPLETED':
        return 'completed';
      default:
        return '';
    }
  }

  public openBase64File(base64: string, fileName: string): Promise<void> {
    return this.fileSaverService.saveBase64(base64, fileName);
  }
}
